import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { from, Subscription, Subject } from 'rxjs';
import { tap, map, concatMap, debounceTime, distinctUntilChanged, finalize, filter} from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocumentStackService } from 'src/app/services/document-stack.service'

import { ProductApiService } from 'src/app/services/product-api.service';
import { RestApiService } from '../../services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-invoice',
  templateUrl: './new-document-dlg-process-invoice.component.html',
  styleUrls: ['./new-document-dlg-process-invoice.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessInvoiceComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;
  private _productInfoQuery: Subscription;

/*
 * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
 */
  @Input() parentDocument: Document;

/*
 * Therefore, to keep source object untouched (immutable ????)
 * we will expect alone/independent copy of DocItems as Input parameter
 * 
 */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  @Input() docDate: Date;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  count: number = -1;

  sourceDocItems: DocItems[];

  @Input() countEmptyDocItems: boolean = false;

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  actions =
    [
      { name: 'На основе валютной цены', value: 1, disabled: false },
      { name: 'Копировать учетку', value: 2, disabled: false },
      { name: 'Удалить существующие позиции', value: 3, disabled: false },
      { name: 'Учитывать пустые строки', value: 10, disabled: false },
    ];

  selectedActions: any = [1, 3];

  private listOptions$ = new Subject<{ currId: number, docDate: Date }>();
  private currencyQuery: Subscription;

  constructor(
    private restApi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private prodApi: ProductApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgProcessInvoiceComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            this.processDocItems();
          }
          break;

        case 'docDate':
          if (this.newDocument) {
            this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            this.processDocItems();
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {

            if (this.parentDocument.items) {
              this.processDocItems();
            }
          }
          break;

        case 'countEmptyDocItems':
          if (this.countEmptyDocItems) {
            if (!this.selectedActions.includes(10)) {
              this.selectedActions.push(10);
            }
          } else {
            if (this.selectedActions.includes(10)) {
              this.selectedActions = this.selectedActions.filter(a => a !== 10);
            }
          }
          this.processDocItems();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessInvoiceComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessInvoiceComponent in ngOnInit');

    /*
     * TODO: Make subscription to newDocument currency rate, because it is quite complex task to wait the set the rate in the main thread
     * Potentially problematic due to different sources ??????
     */

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    let rowSortIndex = 10;

    this.currencyQuery =
      this.listOptions$
        .pipe(
          debounceTime(50),
          // distinctUntilChanged(),
          concatMap(options => this.restApi.getCurrencyInfoByID(options.currId, options.docDate).pipe(
            map(rate => {
              console.log('*** NewDocumentDlgProcessInvoiceComponent in Subscription: data=(' + JSON.stringify(rate) + ')');

              this.blocking.emit(true);

              this.newDocument.DOCRATEVAL = rate[0].CURRATE;
              this.newDocument.items = [];

              rowSortIndex = 0;

              environment.production || console.table(this.sourceDocItems);

              return this.sourceDocItems;
            })
          )),

          concatMap(items => from(items).pipe(
            filter(di => di != null),

            tap(di => console.log('*** NewDocumentDlgProcessInvoiceComponent processing docItem: ' + JSON.stringify(di))),

            filter(di => (this.selectedActions.includes(10) || (di.DOCITEMQTY > 0))),
            map(di => {

              let kVat = ((100.0 + (di.PRODVAT ?? this.globalSettinsData.vatValue)) / 100.0); // <= 1,2 when VAT is 20%

              let ndi: DocItems = {
                ...di,
                ... {
                  DOCITEMID: -2,
                  cloneIndex: 0,
                  U4ETKA: null,
                  DOCITEMCURRID: this.newDocument.DOCCURRID,
                  DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                  PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                  DOCITEMPRICEWOVAT: round1(round2(di.DOCITEMPRICE) / kVat),
                  // Copy price in main currency by default
                  DOCITEMPRICE: round1(round2(di.DOCITEMPRICE) / kVat) * kVat,
                  DOCITEMVPRICE: (round1(round2(di.DOCITEMPRICE) / kVat) * kVat) / this.newDocument.DOCRATEVAL,

                  PAYITEMCLIID: rowSortIndex += 10,
                }
              };

              if (this.selectedActions.includes(1)) {
                //console.log('*** NewDocumentDlgProcessInvoiceComponent doCurrencyBased document ');

                ndi.DOCITEMPRICEWOVAT = round1((di.DOCITEMVPRICE * this.newDocument.DOCRATEVAL) / kVat);
                ndi.DOCITEMPRICE = round2(ndi.DOCITEMPRICEWOVAT * kVat);
                ndi.DOCITEMVPRICE = ndi.DOCITEMPRICE / this.newDocument.DOCRATEVAL;
              }
              ndi.DOCITEMSUM = ndi.DOCITEMPRICE * ndi.DOCITEMQTY;

              if (this.selectedActions.includes(2)) {
                //console.log('*** NewDocumentDlgProcessInvoiceComponent copy U4etka info');
                /*
                 * TODO: Consider whether we have to recalculate the U4ETKA value with actual currency rate
                 */
                ndi.U4ETKA = di.U4ETKA;
              }

              //environment.production || console.table(di);
              //environment.production || console.table(ndi);

              return ndi;
            }),

            concatMap(ndi => this.prodApi.getProdInfoById(
              ndi.PRODID,
              this.newDocument.DOCMANCLIID,
              this.newDocument.DOCCURRID,
              //
              // It depends on document type ????
              //
              this.globalSettinsData.mainStockId,
              this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
              this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
              //
              // Is it on actual date or document date
              // Could depends on....
              //
              new Date()
            )
            .pipe(
              map(data => {
                if (data && data.length > 0) {
                  ndi.prodInfo = data[0];
                }
                this.newDocument.items.push(ndi);
              }))
            ),

            finalize(() => {
              this.count = this.newDocument.items.length;

              this.blocking.emit(false);
            })
          )),
        )
        .subscribe();

    this.listOptions$.next({ currId: this.newDocument.DOCCURRID, docDate: this.newDocument.DOCDATE });
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessInvoiceComponent in processDocItems');

    this.listOptions$.next({ currId: this.newDocument.DOCCURRID, docDate: this.newDocument.DOCDATE });
  }

  onChangeActions(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onChangeActions ' + JSON.stringify(event));

    this.processDocItems();
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onDocTypeChanges ' + JSON.stringify(event));

    if (event.value.includes(1)) {
      console.log('*** NewDocumentDlgProcessInvoiceComponent onDocTypeChanges doCurrencyBased document ' + JSON.stringify(event.value));
/*
 * TODO: Check whether currency of newDocument equal to those in parentDocument
 *       May be we need more sofisticated parameters checking
 */
    }
    if (event.value.includes(2)) {
      console.log('*** NewDocumentDlgProcessInvoiceComponent onDocTypeChanges copy U4etka info ' + JSON.stringify(event.value));
    }

    if (event.value.includes(10)) {
      console.log('*** NewDocumentDlgProcessInvoiceComponent onDocTypeChanges countEmptyDocItems ' + JSON.stringify(event.value));
    }
    console.log('*** NewDocumentDlgProcessInvoiceComponent onDocTypeChanges selectedActions ' + JSON.stringify(this.selectedActions));

    this.processDocItems();
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onClearRows ' + JSON.stringify(event));

    this.newDocument.items = [];
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onRefreshRows ' + JSON.stringify(event));

    this.processDocItems();
  }
}
